import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./IntroduccioIndividuFenofases.module.css";
import * as rutes from "../../routes";
import { Badge, Icon } from "antd";
import PropTypes from "prop-types";
import { omplirIdEspecieIntroduccio } from "../../actions";

class IntroduccioIndividuFenofases extends Component {
  openFenofasesIndividu = () => {
    const { history, especie } = this.props;
    this.props.omplirIdEspecieIntroduccio(especie.idEspecie);
    history.push({
      pathname: rutes.rutaObservacionsIntroduccioFenofasesIndividu
    });
  };

  render() {
    const { especie, numObservacions, numFenofases } = this.props;
    if (!especie) {
      return null;
    }
    return (
      <li className={styles.element}>
        <Badge
          count={
            numObservacions === numFenofases ? (
              <Icon
                type="check-circle"
                theme="filled"
                style={{
                  height: "initial",
                  width: "initial",
                  backgroundColor: "#fff",
                  borderRadius: "100%",
                  boxShadow: "0 0 0 1px #fff",
                  fontSize: "1.1rem",
                  color: "#52c41a"
                }}
              />
            ) : (
                <Icon
                  type="warning"
                  theme="filled"
                  style={{
                    height: "initial",
                    width: "initial",
                    backgroundColor: "#fff",
                    fontSize: "1.1rem",
                    color: "#f5222d"
                  }}
              />
            )
          }
          //Title solo funciona con dot. Con icon no.
          // title={
          //   numObservacions === numFenofases ? (
          //     "Totes les fenofases observades"
          //   ) : (
          //     `Falten ${numFenofases - numObservacions} fenofases per observar`
          //   )
          // }
          style={{
            height: "15px",
            width: "15px"
          }}
        >
          <div
            className={styles.contenidorImatge}
            role="button"
            tabIndex="0"
            onClick={this.openFenofasesIndividu}
          >
            <img
              src={especie.urlFotoEspecie}
              alt={"Anar a fenofases " + especie.nomEspecie}
            />
          </div>
          <span>{especie.nomEspecie}</span>
        </Badge>
      </li>
    );
  }
}

IntroduccioIndividuFenofases.propTypes = {
  especie: PropTypes.object,
  numObservacions: PropTypes.number,
  numFenofases: PropTypes.number,
  omplirIdEspecieIntroduccio: PropTypes.func.isRequired
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  omplirIdEspecieIntroduccio
})(IntroduccioIndividuFenofases);
